import PropTypes         from 'prop-types';
import BaseDocumentTitle from 'react-document-title';
import { withProps }     from 'recompose';

export const DocumentTitle = withProps(
  ({title, excludeDefaultSuffix}) => {

    let suffix;

    if (!excludeDefaultSuffix) {

      suffix = 'MyCommunity Directory, Lambeth';

      if (title) {

        suffix = ' | ' + suffix;

      }

    }

    return {title: `${title}${suffix}`};

  }
)(BaseDocumentTitle);


DocumentTitle.propTypes = {

  // Title for the document.
  title: PropTypes.string,

  // Flag to indicate whether to remove the default suffix.
  excludeDefaultSuffix: PropTypes.bool,

};


DocumentTitle.defaultProps = {

  title: '',

  excludeDefaultSuffix: false,

};



// WEBPACK FOOTER //
// ./src/components/page_elements/DocumentTitle.js